//import '@/assets/styles/global.scss'
//import '@/assets/styles/css/app.css'
import '@/assets/styles/css/bootstrap.css'
import '@/assets/styles/index.scss'
import App from '@/views/App'
import { createApp } from '@tellus/core'
import { createHttp } from '@tellus/http'
import { createLayout } from '@tellus/layout'
import { createLocale } from '@tellus/locale'
import { createRouter } from '@tellus/router'
import { createUI } from '@tellus/ui'
import '@tellus/ui/lib/theme-chalk/index.css'
import installSvgIcon from './plugins/icon-park'
import { registerTableScrollTop } from './plugins/v-directive'
import { registerStore } from './store'

const app = createApp(App)
// svg icon
installSvgIcon(app.context._vue)
app.use(createHttp())
app.use(createUI())
app.use(createLocale())
app.use(createLayout())
app.use(createRouter())
registerStore(app)
registerTableScrollTop(app)
app.mount('#app')

